import throttle from 'lodash-es/throttle.js';
import getRemBase from 'propel/getRemBase';

const propelInit = function() {
const openAccordionVerticalItem = (items, itemToOpen) => {
	const itemsArray = Array.from(items);

	const previousOpenItem = itemsArray.find((item) =>
		item.classList.contains('block-accordion-vertical-item--open')
	);

	const targetIndex = itemsArray.indexOf(itemToOpen);

	const previousIndex = previousOpenItem
		? itemsArray.indexOf(previousOpenItem)
		: -1;

	items.forEach((item) => {
		const isTarget = item === itemToOpen;

		const button = item.querySelector(
			'.block-accordion-vertical-item__button'
		);

		item.classList.toggle('block-accordion-vertical-item--open', isTarget);

		if (button) {
			button.setAttribute('aria-expanded', String(isTarget));
		}
	});

	if (previousIndex !== -1 && previousIndex !== targetIndex) {
		const openingToTheRight = targetIndex > previousIndex;

		itemToOpen.classList.toggle(
			'block-accordion-vertical-item--anchor-right',
			openingToTheRight
		);

		previousOpenItem.classList.toggle(
			'block-accordion-vertical-item--anchor-right',
			!openingToTheRight
		);
	}
};

const focusAccordionVerticalContent = (item) => {
	const content = item.querySelector(
		'.block-accordion-vertical-item__content'
	);

	if (!content) {
		return;
	}

	const focusableSelector =
		'a[href], button, input, select, textarea, [tabindex]';

	const focusable = content.querySelector(focusableSelector);

	if (focusable) {
		focusable.focus();

		return;
	}

	content.setAttribute('tabindex', '-1');
	content.focus();
};

const initAccordionVerticalContent = (content) => {
	const isJsReady = content.classList.contains(
		'block-accordion-vertical-wrapper__content--js-ready'
	);

	if (isJsReady) {
		return;
	}

	const items = content.querySelectorAll('.block-accordion-vertical-item');

	if (!items.length) {
		return;
	}

	items.forEach((item) => {
		const button = item.querySelector(
			'.block-accordion-vertical-item__button'
		);

		if (!button) {
			return;
		}

		button.addEventListener('click', () => {
			openAccordionVerticalItem(items, item);
			focusAccordionVerticalContent(item);
		});
	});

	openAccordionVerticalItem(items, items[0]);

	content.classList.add(
		'block-accordion-vertical-wrapper__content--js-ready'
	);
};

const accordionVerticalContents = document.querySelectorAll(
	'.block-accordion-vertical-wrapper__content'
);

if (accordionVerticalContents.length) {
	accordionVerticalContents.forEach(initAccordionVerticalContent);
}

const setAccordionVerticalMinContentWidth = (content) => {
	content.style.removeProperty('--minContentWidth');

	content
		.querySelectorAll('.block-accordion-vertical-item__content')
		.forEach((itemContent) => {
			itemContent.style.removeProperty('--minContentWidth');
		});

	const openItemContent = content.querySelector(
		'.block-accordion-vertical-item--open .block-accordion-vertical-item__content'
	);

	if (!openItemContent) {
		return;
	}

	const { width } = openItemContent.getBoundingClientRect();

	if (!width) {
		return;
	}

	content.style.setProperty(
		'--minContentWidth',
		`${width / getRemBase()}rem`
	);
};

const setAccordionVerticalMinContentWidths = () => {
	accordionVerticalContents.forEach(setAccordionVerticalMinContentWidth);
};

const setAccordionVerticalClosedItemWidth = (content) => {
	content.style.removeProperty('--closedItemWidth');

	const closedItem = content.querySelector(
		'.block-accordion-vertical-item:not(.block-accordion-vertical-item--open)'
	);

	if (!closedItem) {
		return;
	}

	const { width } = closedItem.getBoundingClientRect();

	if (!width) {
		return;
	}

	content.style.setProperty(
		'--closedItemWidth',
		`${width / getRemBase()}rem`
	);
};

const setAccordionVerticalClosedItemWidths = () => {
	accordionVerticalContents.forEach(setAccordionVerticalClosedItemWidth);
};

const updateAccordionVerticalWidths = () => {
	setAccordionVerticalMinContentWidths();
	setAccordionVerticalClosedItemWidths();
};

if (accordionVerticalContents.length) {
	updateAccordionVerticalWidths();

	window.addEventListener(
		'resize',
		throttle(updateAccordionVerticalWidths, 100)
	);
}

};
propelInit();
window.propel = window.propel || {};
window.propel.blocks = window.propel.blocks || {};
window.propel.blocks['accordion-vertical'] = window.propel.blocks['accordion-vertical'] || {};
window.propel.blocks['accordion-vertical'].script = propelInit;
